export enum ParameterType {
    NONE = 'NONE', STRING = 'STRING', NUMBER = 'NUMBER'
}
